export const locations = [
  {
    slug: "serris",
    city: "Serris",
    path: "/menage-domicile-serris/",
    title: "Femme de ménage hebdomadaire à Serris | Arklis",
    h1: "Service de ménage hebdomadaire à domicile à Serris",
    description:
      "Arklis propose un service de ménage hebdomadaire à Serris pour les particuliers recherchant un entretien régulier et suivi de leur domicile.",
    intro:
      "À Serris, Arklis intervient chaque semaine afin d'assurer l'entretien courant du logement et de construire une organisation stable avec le foyer.",
    angle:
      "Le service s'adresse aux familles et particuliers qui veulent retrouver un intérieur entretenu sans devoir réorganiser leur semaine autour des tâches ménagères.",
    nearby: ["Chessy", "Montévrain", "Bailly-Romainvilliers"]
  },
  {
    slug: "chessy",
    city: "Chessy",
    path: "/menage-domicile-chessy/",
    title: "Ménage hebdomadaire à Chessy | Arklis Val d'Europe",
    h1: "Ménage à domicile chaque semaine à Chessy",
    description:
      "Service de ménage hebdomadaire à Chessy avec Arklis : une intervention régulière pour l'entretien courant du domicile.",
    intro:
      "À Chessy, Arklis accompagne les foyers qui recherchent un service de ménage à domicile régulier, clair et facile à intégrer dans leur quotidien.",
    angle:
      "Le passage hebdomadaire permet de suivre les habitudes du logement, d'ajuster les priorités avec le foyer et de maintenir un cadre de vie agréable.",
    nearby: ["Serris", "Montévrain", "Coupvray"]
  },
  {
    slug: "montevrain",
    city: "Montévrain",
    path: "/menage-domicile-montevrain/",
    title: "Femme de ménage hebdomadaire à Montévrain | Arklis",
    h1: "Service de ménage hebdomadaire à Montévrain",
    description:
      "Arklis intervient chaque semaine à Montévrain pour l'entretien courant du domicile des particuliers.",
    intro:
      "À Montévrain, Arklis propose une organisation simple : un ménage à domicile chaque semaine pour garder le logement entretenu dans la durée.",
    angle:
      "L'intervention régulière aide à répartir les priorités entre sols, poussière, cuisine, sanitaires et surfaces courantes selon les usages du foyer.",
    nearby: ["Serris", "Chessy", "Magny-le-Hongre"]
  },
  {
    slug: "bailly-romainvilliers",
    city: "Bailly-Romainvilliers",
    path: "/menage-domicile-bailly-romainvilliers/",
    title: "Ménage hebdomadaire à Bailly-Romainvilliers | Arklis",
    h1: "Ménage à domicile hebdomadaire à Bailly-Romainvilliers",
    description:
      "Arklis propose le ménage hebdomadaire à domicile à Bailly-Romainvilliers pour les foyers souhaitant un suivi régulier.",
    intro:
      "À Bailly-Romainvilliers, Arklis aide les particuliers à installer une routine d'entretien stable, avec un passage chaque semaine.",
    angle:
      "Le service vise la continuité : mieux connaître le logement, respecter les habitudes du foyer et garder une organisation lisible dans le temps.",
    nearby: ["Serris", "Magny-le-Hongre", "Coupvray"]
  },
  {
    slug: "magny-le-hongre",
    city: "Magny-le-Hongre",
    path: "/menage-domicile-magny-le-hongre/",
    title: "Femme de ménage hebdomadaire à Magny-le-Hongre | Arklis",
    h1: "Ménage hebdomadaire à domicile à Magny-le-Hongre",
    description:
      "Arklis propose un service de ménage hebdomadaire à Magny-le-Hongre pour les particuliers de Val d'Europe.",
    intro:
      "À Magny-le-Hongre, Arklis se concentre sur l'entretien hebdomadaire du domicile pour offrir un cadre suivi et rassurant.",
    angle:
      "Chaque échange permet de préciser les priorités du foyer, afin que le passage hebdomadaire reste utile, régulier et adapté au logement.",
    nearby: ["Bailly-Romainvilliers", "Coupvray", "Montévrain"]
  },
  {
    slug: "coupvray",
    city: "Coupvray",
    path: "/menage-domicile-coupvray/",
    title: "Ménage hebdomadaire à Coupvray | Arklis Val d'Europe",
    h1: "Service de ménage hebdomadaire à Coupvray",
    description:
      "Arklis intervient chaque semaine à Coupvray pour le ménage à domicile et l'entretien courant du logement.",
    intro:
      "À Coupvray, Arklis accompagne les foyers qui souhaitent déléguer leur ménage à domicile dans un cadre régulier et suivi.",
    angle:
      "Le rythme hebdomadaire permet de créer une continuité avec le foyer et d'entretenir le logement selon ses usages réels.",
    nearby: ["Chessy", "Magny-le-Hongre", "Bailly-Romainvilliers"]
  }
];
